export const ui = {
  items: []
};